import { twJoin } from "tailwind-merge";

import type { ContainerBreakpoint, ContainerResponsiveValue } from "../contracts/responsive";

export function resolveContainerClasses<TValue extends PropertyKey>(
  value: ContainerResponsiveValue<TValue>,
  baseClasses: Record<TValue, string>,
  containerClasses: Record<ContainerBreakpoint, Record<TValue, string>>,
): string {
  if (typeof value !== "object" || value === null) {
    return baseClasses[value];
  }

  return twJoin(
    baseClasses[value.base],
    ...Object.entries(value.container).map(([breakpoint, responsiveValue]) =>
      responsiveValue ? containerClasses[breakpoint as ContainerBreakpoint][responsiveValue] : undefined,
    ),
  );
}
